// PRD 3.2: 推荐问题列表
// V1.1：前端硬编码；V1.2 将切换为 /api/suggestions + 后端 Redis 缓存
// 主题方向对齐 PRD 示例（Agent / MCP 等 AI 工程话题）

const DEFAULT_SUGGESTIONS = [
  // —— 岗位分身方法论（对齐 10_ai_robot_agent.md）
  '岗位 AI 分身是什么？',
  '岗位分身能用在哪些行业？',
  // --公司介绍
  '你们是谁，能做什么？',
  '企业 AI 转型的难点是什么？',
  '什么样的企业适合上 Agent？',
  '快退休的专家经验能留住吗？',
  '为什么你们觉得自己能搞定？',
  // —— 技术对比
  '就用 Claude Code 不行吗？',
  // —— 落地与安全
  '支持国产化硬件部署吗？',
  '数据安全怎么保证？',
  '服务器配置要求是什么？',
  '客户端配置要求是什么？',
  // —— 公司与招聘
  '你们有多少客户？',
  '你们在招什么人？',
  // —— 投资人相关（对齐 07-investor-faq.md）
  '这个行业的市场有多大？',
  '这个行业怎么规模化？',
  '你们的竞争壁垒在哪？',
  '融过资吗？下一步计划？',
  
];

/**
 * 加载推荐问题。
 * V1.1 直接返回本地数组；V1.2 可改为 fetch('/api/suggestions')。
 * @returns {Promise<string[]>}
 */
export async function loadSuggestions() {
  return DEFAULT_SUGGESTIONS;
}
